import {
  isCommunityCategory,
  type CommunityCategory,
} from "@checklist/shared";

/** Read `category` from a location search string. Unknown or empty slugs are null. */
export function categoryFromSearch(search: string): CommunityCategory | null {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const value = new URLSearchParams(raw).get("category");
  if (!value || !isCommunityCategory(value)) return null;
  return value;
}

/** `/community` with category and q omitted when empty. */
export function categoryHref(category: CommunityCategory | null, q: string): string {
  const qs = categorySearch(category, q);
  return qs ? `/community?${qs}` : "/community";
}

/** Query string (no leading `?`) matching `categoryHref`. Empty when both are blank. */
export function categorySearch(category: CommunityCategory | null, q: string): string {
  const params = new URLSearchParams();
  if (category) params.set("category", category);
  const trimmed = q.trim();
  if (trimmed) params.set("q", trimmed);
  return params.toString();
}

/**
 * The URL effect must not copy `q` back into the field when it already matches
 * the committed query, or a keystroke typed after the debounce is overwritten.
 */
export function shouldSyncQueryFromUrl(urlQuery: string, currentQuery: string): boolean {
  return urlQuery !== currentQuery;
}

/** Notice when `category` is present but not a known slug, including an empty value. */
export function unknownCategoryMessage(search: string): string | null {
  const raw = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(raw);
  if (!params.has("category")) return null;
  const value = params.get("category");
  if (value && isCommunityCategory(value)) return null;
  return "Unknown category - showing all.";
}
